import { render, staticRenderFns } from "./right-panel.vue?vue&type=template&id=bf667210&scoped=true&"
import script from "./right-panel.vue?vue&type=script&lang=js&"
export * from "./right-panel.vue?vue&type=script&lang=js&"
import style0 from "./right-panel.vue?vue&type=style&index=0&id=bf667210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf667210",
  null
  
)

export default component.exports